import { Outlet } from 'react-router'

export const PublicLayout = () => <Outlet />
